<!--  eslint-disable  -->
<template>
  <div class="component-calender">
    <div class="calender">
      <div class="tools">
        <span class="tools-btn" @click="close">关闭</span>
        <span @click="lastMonth">《</span>
        <span class="nowday" @click="toggleYear">{{currentStr}}</span>
        <span @click="nextMonth">》</span>
        <span class="tools-btn" @click="chooseDate">确定</span>
      </div>
      <div class="weeks" v-show="!isShowYear">
        <div class="item" v-for="(item, index) in weeks" :key="index">{{item}}</div>
      </div>
      <div class="years" v-show="isShowYear">
        <div
          class="year"
          :class="{ 'year-active' : currenYear - index === current.year }"
          v-for="(item, index) in len"
          :year="index"
          @click="setYear(currenYear - index)"
        >
          <span v-if="type === 'before'">{{currenYear - index}}</span>
          <span v-else>{{currenYear + index}}</span>
        </div>
      </div>
      <div class="day-content" v-show="!isShowYear">
        <div class="item" v-for="(item, index) in currentDate.week" :last="index">
          <span class="unable">{{lastDays - currentDate.week + index + 1}}</span>
        </div>
        <div class="item" v-for="(item, index) in days" :key="index" @click="setDay(item)">
          <span :class="{'day': item === current.day, 'data' : isChoose(item)}">{{item}}</span>
        </div>
        <div class="item" v-for="(item, index) in nextDate" :next="index">
          <span class="unable">{{item}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      current: {
        year: '',
        month: '',
        day: '',
      },
      weeks: ['日', '一', '二', '三', '四', '五', '六'],
      currenYear: '',
      isShowYear: false,
      year: '',
      month: '',
      day: '',
    };
  },
  props: {
    date: {
      type: String, // 时间戳
    },
    type: {
      type: String,
      default: 'before', // 日期向前后推
    },
    point: {
      type: Array,
      default: () => [], // 可点击day
    },
    len: {
      type: Number,
      default: 10, // 年限
    },
    unable: {
      type: Boolean, // 是否开启禁选样式
      default: false,
    },
  },
  computed: {
    currentStr() {
      const { year, month } = this.current;
      return `${year}年${month + 1}月`;
    },
    currentDate() {
      const lastMonth = this.current.month === 0 ? 11 : this.current.month - 1;
      const nextMonth = this.current.month === 11 ? 0 : this.current.month + 1;
      return {
        year: this.current.year,
        month: this.current.month,
        last_month: lastMonth,
        next_month: nextMonth,
        week: new Date(this.current.year, this.current.month, 1).getDay(),
      };
    },
    days() {
      const { year, month } = this.current;
      return new Date(year, month + 1, 0).getDate();
    },
    lastDays() {
      const lastMonth = this.current.month === 0 ? 11 : this.current.month - 1;
      return new Date(this.current.year, lastMonth + 1, 0).getDate();
    },
    nextDate() {
      const week = new Date(this.current.year, this.current.month, 1).getDay();
      return 42 - this.days - week;
    },
  },
  methods: {
    init() {
      const date = this.date ? new Date(this.date) : new Date();
      this.currenYear = new Date().getFullYear();
      this.current.year = date.getFullYear();
      this.current.month = date.getMonth();
      this.year = date.getFullYear();
      this.month = date.getMonth();
      this.day = date.getDate();
      if (this.date) {
        this.current.day = date.getDate();
      }
    },
    lastMonth() {
      if (this.current.month === 0) {
        this.current.year -= 1;
      }
      this.current.month = this.currentDate.last_month;
      this.current.day = '';
      this.$emit('change', this.checkdate());
    },
    nextMonth() {
      if (this.current.month === 11) {
        this.current.year += 1;
      }
      this.current.month = this.currentDate.next_month;
      this.current.day = '';
      this.$emit('change', this.checkdate());
    },
    isChoose(day) {
      return this.point.includes(day);
    },
    setDay(day) {
      if (this.current.day === day) return;
      if (!this.isChoose(day) && this.unable) return;
      this.current.day = day;
      this.$emit('change', this.checkdate());
    },
    checkdate() {
      const date = { ...this.current };
      const dateTime = new Date(this.current.year, this.current.month, this.current.day).getTime();
      date.month += 1;
      date.dateTime = dateTime / 1000;
      return date;
    },
    chooseDate() {
      if (!this.current.day) return;
      this.year = this.current.year;
      this.month = this.current.month;
      this.day = this.current.day;
      if (this.current.day) {
        this.$emit('confirm', this.checkdate());
      }
    },
    toggleYear() {
      this.isShowYear = !this.isShowYear;
    },
    setYear(year) {
      this.current.year = year;
      this.isShowYear = false;
      this.current.day = '';
      this.$emit('change', this.checkdate());
    },
    close() {
      this.current.year = this.year;
      this.current.month = this.month;
      this.current.day = this.day;
      this.$emit('close', this.checkdate());
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
 @import '@/styles/variables.scss';
.component-calender {
  // position: absolute;
  // top: 0;
  // left: 0;
  // width: 100%;
  // height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  // z-index: 9999;
  width: 400px;
  // height: 200px;
  .calender {
    // position: fixed;
    // bottom: 0;
    // left: 0;
    // z-index: 999;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: auto;
    width: 100%;
    background-color: #fff;
    .nowday {
      display: block;
      width: 90px;
    }
    .tools {
      height: 40px;
      border-top: 1px solid #f3f3f3;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 40px;
      padding: 0 10px;
      .tools-btn {
        // color
        color: $info;
        cursor: pointer;
      }
    }
    .weeks {
      height: 30px;
      display: flex;
      flex-direction: row;
      padding: 0 2%;
      border-bottom: 1px solid #f3f3f3;
      .item {
        flex: 1;
        line-height: 30px;
        text-align: center;
      }
    }
    .years {
      height: 260px;
      overflow-y: auto;
      .year {
        text-align: center;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #f3f3f3;
        font-size: 14px;
        color: #808080;
      }
      .year-active {
        color: $info;
        font-size: 16px;
      }
    }
    .day-content {
      height: 230px;
      padding-top: 0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding-left: 1.5%;
      color: #999;
      .item {
        width: 14%;
        line-height: 30px;
        margin: 2px 0;
        text-align: center;
        padding: 2px;
        box-sizing: border-box;
        font-size: 14px;
        cursor: pointer;
        .day {
          display: block;
          border-radius: 3px;
          background-color: $info;
          color: #fff !important;
        }
        .data {
          color: $info;
        }
        .unable {
          color: #ccc;
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
